import React, { useRef } from 'react';

// Define the 4 wave states for a smoother morphing cycle (Gentler Curves)
const pA = "M0,150 C182,180 364,120 545,150 S909,180 1091,150 L1091,408 L0,408 Z";
const pB = "M0,150 C182,165 364,135 545,150 S909,165 1091,150 L1091,408 L0,408 Z";
const pC = "M0,150 C182,120 364,180 545,150 S909,120 1091,150 L1091,408 L0,408 Z";
const pD = "M0,150 C182,135 364,165 545,150 S909,135 1091,150 L1091,408 L0,408 Z";

const AnimatedWaves = () => {
  const wavePathRef = useRef(null);
  const wavePathBgRef = useRef(null);

  // Fish color chosen to be visible against wave colors
  const fishColor = "#79CDCD"; 

  return (
    <div style={{ 
      width: '100%', 
      overflow: 'hidden', 
      lineHeight: 0,
      border: 'none !important',
      boxShadow: 'none !important',
      padding: 0,
      margin: 0,
      marginBottom: -1,
      fontSize: 0,
      display: 'block',
      verticalAlign: 'bottom'
    }}>
      <style>
        {`
          @keyframes waveAnimation {
            0% { d: path("${pA}"); }
            25% { d: path("${pB}"); }
            50% { d: path("${pC}"); }
            75% { d: path("${pD}"); }
            100% { d: path("${pA}"); }
          }
          @keyframes waveAnimationBg {
            0% { d: path("${pC}"); }
            25% { d: path("${pD}"); }
            50% { d: path("${pA}"); }
            75% { d: path("${pB}"); }
            100% { d: path("${pC}"); }
          }
          .wave-path {
            animation: waveAnimation 7.5s ease-in-out infinite;
          }
          .wave-path-bg {
            animation: waveAnimationBg 7.5s ease-in-out infinite;
          }
        `}
      </style>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="100%"
        viewBox="0 0 1091 408"
        xmlSpace="preserve"
        preserveAspectRatio="xMidYMin slice" 
        style={{ 
          display: 'block', 
          width: '100%', 
          height: 'auto',
          verticalAlign: 'bottom',
          marginBottom: -1
        }} 
      >
        <defs>
          <g id="fish-graphic">
            <path fill={fishColor} d="M431.503,214.091c-13.844-35.103-36.991-65.519-66.941-87.96c-30.127-22.573-65.671-35.893-102.892-38.575l-76.768-38.814c-0.151-0.077-0.306-0.149-0.462-0.216c-3.47-1.485-7.017-2.237-10.543-2.237c-14.239,0-24.978,11.991-24.978,27.892c0,10.259,4.691,19.05,10.124,29.228c0.684,1.282,1.377,2.581,2.075,3.908c-32.079,15.982-59.87,41.013-79.482,71.591l-52.46-32.163c-0.331-0.203-0.677-0.381-1.034-0.535c-2.722-1.165-5.516-1.755-8.304-1.755C8.528,144.454,0,153.856,0,166.324c0,14.541,16.277,39.445,24.2,50.704C16.277,228.286,0,253.19,0,267.731c0,12.468,8.528,21.87,19.838,21.87c2.788,0,5.583-0.591,8.306-1.756c0.356-0.153,0.702-0.332,1.033-0.534l52.455-32.159c19.558,30.612,46.449,54.973,78.465,71.083c-0.529,1.035-1.053,2.053-1.571,3.059c-5.154,10.002-9.605,18.641-9.605,28.586c0,15.899,10.737,27.89,24.977,27.891c0.001,0,0.002,0,0.003,0c3.524,0,7.071-0.753,10.541-2.238c0.164-0.07,0.326-0.146,0.484-0.227l71.589-36.48c77.367-3.531,145.924-53.162,174.989-126.865C432.246,218.075,432.246,215.977,431.503,214.091z M322.279,314.593c-22.115-23.023-35.251-59.884-35.251-99.28c0-18.159,2.696-35.639,8.013-51.953c1.369-4.201-0.927-8.716-5.128-10.085c-4.199-1.366-8.716,0.926-10.085,5.127c-5.839,17.918-8.8,37.065-8.8,56.911c0,40.908,13.128,79.621,35.47,105.676c-16.634,5.839-34.237,9.262-52.351,9.921c-1.163,0.042-2.304,0.338-3.341,0.867l-72.881,37.139c-1.392,0.568-2.745,0.856-4.027,0.856c0,0,0,0-0.001,0c-5.202,0-8.978-5.001-8.978-11.891c0-6.066,3.283-12.438,7.828-21.258c1.637-3.177,3.492-6.778,5.344-10.689c0.917-1.939,1.018-4.167,0.278-6.181c-0.74-2.014-2.258-3.646-4.213-4.531c-34.721-15.705-63.414-41.679-82.976-75.116c-1.086-1.856-2.873-3.197-4.959-3.72c-0.643-0.161-1.295-0.24-1.946-0.24c-1.463,0-2.912,0.402-4.182,1.18l-58.691,35.982c-0.556,0.195-1.081,0.293-1.565,0.293c-2.26,0-3.838-2.414-3.838-5.87c0-8.872,14.32-32.206,24.489-45.942c2.094-2.828,2.094-6.694,0-9.522C30.32,198.531,16,175.196,16,166.324c0-3.457,1.578-5.87,3.839-5.87c0.484,0,1.009,0.098,1.565,0.292l58.689,35.982c1.833,1.125,4.042,1.462,6.128,0.939s3.873-1.864,4.959-3.72c19.498-33.326,49.344-60.172,84.041-75.594c1.979-0.879,3.516-2.522,4.262-4.555c0.745-2.032,0.636-4.28-0.305-6.23c-2.07-4.294-4.168-8.226-6.02-11.694c-4.783-8.962-8.239-15.438-8.239-21.695c0-6.891,3.775-11.892,8.978-11.892c1.285,0,2.644,0.289,4.039,0.859l77.963,39.418c0.966,0.489,2.021,0.776,3.103,0.845c15.503,0.985,30.701,3.987,45.277,8.875c-3.864,4.778-7.465,9.967-10.75,15.523c-2.248,3.803-0.988,8.709,2.815,10.958c1.277,0.756,2.68,1.115,4.063,1.115c2.735,0,5.401-1.404,6.895-3.93c3.822-6.464,8.103-12.343,12.751-17.526c12.271,5.459,23.981,12.317,34.914,20.509c26.739,20.035,47.596,46.987,60.466,78.091C397.18,261.144,363.465,295.576,322.279,314.593z"/>
            <path fill={fishColor} d="M344.061,169.065c-13.132,0-23.815,10.684-23.815,23.816s10.684,23.816,23.815,23.816s23.815-10.684,23.815-23.816S357.192,169.065,344.061,169.065z M344.061,200.697c-4.31,0-7.815-3.506-7.815-7.816s3.506-7.816,7.815-7.816s7.815,3.506,7.815,7.816S348.37,200.697,344.061,200.697z"/>
          </g>
        </defs>

        {/* Background wave path */}
        <path
          ref={wavePathBgRef}
          className="wave-path-bg"
          fill="#118294"
          stroke="none"
          d={pC}
        />

        {/* Fish 1 */}
        <use xlinkHref="#fish-graphic" transform="translate(100 220) scale(0.15)">
          <animateTransform 
            attributeName="transform" 
            type="translate"
            values="0 0; 800 10; 0 0" 
            keyTimes="0; 0.5; 1"
            dur="15s" 
            repeatCount="indefinite"
            additive="sum" />
          <animateTransform 
            attributeName="transform" 
            type="scale"
            values="1 1; 1 1; -1 1; -1 1; 1 1"
            keyTimes="0; 0.499; 0.5; 0.999; 1"
            dur="15s" 
            repeatCount="indefinite"
            additive="sum" />
        </use>
        
        {/* Fish 2 */}
        <use xlinkHref="#fish-graphic" transform="translate(800 250) scale(0.12)">
           <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0; -700 10; 0 0" 
            keyTimes="0; 0.5; 1"
            dur="12s"
            repeatCount="indefinite"
            additive="sum" />
           <animateTransform 
            attributeName="transform" 
            type="scale"
            values="-1 1; -1 1; 1 1; 1 1; -1 1"
            keyTimes="0; 0.499; 0.5; 0.999; 1"
            dur="12s" 
            repeatCount="indefinite"
            additive="sum" />
        </use>

        {/* Fish 3 */}
        <use xlinkHref="#fish-graphic" transform="translate(300 280) scale(0.18)">
           <animateTransform
            attributeName="transform"
            type="translate"
            values="0 0; 500 -15; 0 0"
            keyTimes="0; 0.5; 1"
            dur="18s"
            begin="-5s"
            repeatCount="indefinite"
            additive="sum" />
           <animateTransform 
            attributeName="transform" 
            type="scale"
            values="1 1; 1 1; -1 1; -1 1; 1 1"
            keyTimes="0; 0.499; 0.5; 0.999; 1"
            dur="18s" 
            begin="-5s"
            repeatCount="indefinite"
            additive="sum" />
        </use>
        
        {/* Front wave path */}
        <path
          ref={wavePathRef}
          className="wave-path"
          fill="#1E9FB4"
          fillOpacity={0.7} 
          stroke="none"
          d={pA}
        />

      </svg>
    </div>
  );
};

export default AnimatedWaves; 